// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.parallaxVerticalAnimation = function parallaxVerticalAnimation() {
  const parallaxVerticalElsArr = document.querySelectorAll(
    '[data-parallax-vertical-animation]'
  );

  if (parallaxVerticalElsArr.length && window.innerWidth > 1024) {
    parallaxVerticalElsArr.forEach((el) => {
      if (!el.classList.contains('is-init-parallax-vertical-animation')) {
        el.classList.add('is-init-parallax-vertical-animation');

        let startY = 100;
        let endY = 20;

        let startTrigger = 90;
        let endTrigger = 10;

        if (el.hasAttribute('data-parallax-vertical-later-start')) {
          startTrigger = 70;
          endTrigger = 5;
          endY = 0;
        }

        const attrValue = el.getAttribute('data-parallax-vertical-animation');

        let startPosition = 10;
        let endPosition = -20;

        if (attrValue) {
          const [startStr, endStr] = attrValue.split(',');
          startPosition = parseFloat(startStr) || 0;
          endPosition = parseFloat(endStr) || 0;
        }

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: `top-=${startY}vh ${startTrigger}%`,
            end: `bottom+=${endY}vh ${endTrigger}%`,
            scrub: 0.85,
            // markers: true,
            invalidateOnRefresh: true,
            onUpdate: (self) => {
              const progress = self.progress;

              el.style.transform = `translateY(${gsap.utils.interpolate(
                startPosition,
                endPosition,
                progress
              )}vh)`;
            },
          },
        });
      }
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  parallaxVerticalAnimation();
}
